import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import sunImageURL from 'url:../../public/assets/images/sun.jpg'
import cloudImageURL from 'url:../../public/assets/images/cloud.jpg'
import cloudSunImageURL from 'url:../../public/assets/images/cloud-sun.jpg'
import snowfallImageURL from 'url:../../public/assets/images/snowfall.jpg'
import rainImageURL from 'url:../../public/assets/images/rain.jpg'
import thunderImageURL from 'url:../../public/assets/images/thunder.jpg'

export type DayWeather = {
  dayOfWeek: string
  icon: React.ReactNode
  dayTemp: number
  nightTemp: number
}

export type ProjectWeather = {
  nextDaysWeather: DayWeather[]
  currentTempreture: number
  icon: React.ReactNode
  locationName: string
  date: string
  description: string
  backImage: string
}

export type WeatherCodeMetadata = {
  description: string
  descriptionShort: string
  icon: string
  weatherIcon: React.ReactNode
  imageBack: string
}

export type WeatherCodeRegistry = Record<number, WeatherCodeMetadata>

export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const weatherCodeRegistry: WeatherCodeRegistry = {
  0: {
    description: 'Clear sky',
    descriptionShort: 'Sunny',
    icon: 'fa-regular fa-sun',
    weatherIcon: <Icon icon={Icons.faSun} />,
    imageBack: sunImageURL,
  },
  1: {
    description: 'Mainly clear, partly cloudy, and overcast',
    descriptionShort: 'Mainly Sunny',
    icon: 'fa-solid fa-cloud-sun',
    weatherIcon: <Icon icon={Icons.faCloudSun} />,
    imageBack: cloudSunImageURL,
  },
  2: {
    description: 'Mainly clear, partly cloudy, and overcast',
    descriptionShort: 'Partly Cloudy',
    icon: 'fa-solid fa-cloud-sun',
    weatherIcon: <Icon icon={Icons.faCloudSun} />,
    imageBack: cloudSunImageURL,
  },
  3: {
    description: 'Mainly clear, partly cloudy, and overcast',
    descriptionShort: 'Cloudy',
    icon: 'fa-solid fa-cloud-sun',
    weatherIcon: <Icon icon={Icons.faCloudSun} />,
    imageBack: cloudSunImageURL,
  },
  45: {
    description: 'Fog and depositing rime fog',
    descriptionShort: 'Foggy',
    icon: 'fa-solid fa-smog',
    weatherIcon: <Icon icon={Icons.faSmog} />,
    imageBack: cloudImageURL,
  },
  48: {
    description: 'Fog and depositing rime fog',
    descriptionShort: 'Rime Fog',
    icon: 'fa-solid fa-smog',
    weatherIcon: <Icon icon={Icons.faSmog} />,
    imageBack: cloudImageURL,
  },
  51: {
    description: 'Drizzle: Light, moderate, and dense intensity',
    descriptionShort: 'Light Drizzle',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  53: {
    description: 'Drizzle: Light, moderate, and dense intensity',
    descriptionShort: 'Drizzle',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  55: {
    description: 'Drizzle: Light, moderate, and dense intensity',
    descriptionShort: 'Heavy Drizzle',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  56: {
    description: 'Freezing Drizzle: Light and dense intensity',
    descriptionShort: 'Light Freezing Drizzle',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  57: {
    description: 'Freezing Drizzle: Light and dense intensity',
    descriptionShort: 'Freezing Drizzle',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  61: {
    description: 'Rain: Slight, moderate and heavy intensity',
    descriptionShort: 'Light Rain',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  63: {
    description: 'Rain: Slight, moderate and heavy intensity',
    descriptionShort: 'Rain',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  65: {
    description: 'Rain: Slight, moderate and heavy intensity',
    descriptionShort: 'Heavy Rain',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  66: {
    description: 'Freezing Rain: Light and heavy intensity',
    descriptionShort: 'Light Freezing Rain',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  67: {
    description: 'Freezing Rain: Light and heavy intensity',
    descriptionShort: 'Freezing Rain',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  71: {
    description: 'Snow fall: Slight, moderate, and heavy intensity',
    descriptionShort: 'Light Snow',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  73: {
    description: 'Snow fall: Slight, moderate, and heavy intensity',
    descriptionShort: 'Snow',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  75: {
    description: 'Snow fall: Slight, moderate, and heavy intensity',
    descriptionShort: 'Heavy Snow',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  77: {
    description: 'Snow grains',
    descriptionShort: 'Snow Grains',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  80: {
    description: 'Rain showers: Slight, moderate, and violent',
    descriptionShort: 'Light Showers',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  81: {
    description: 'Rain showers: Slight, moderate, and violent',
    descriptionShort: 'Showers',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  82: {
    description: 'Rain showers: Slight, moderate, and violent',
    descriptionShort: 'Heavy Showers',
    icon: 'fa-cloud-showers-heavy',
    weatherIcon: <Icon icon={Icons.faCloudShowersHeavy} />,
    imageBack: rainImageURL,
  },
  85: {
    description: 'Snow showers slight and heavy',
    descriptionShort: 'Light Snow Showers',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  86: {
    description: 'Snow showers slight and heavy',
    descriptionShort: 'Snow Showers',
    icon: 'fa-solid fa-snowflake',
    weatherIcon: <Icon icon={Icons.faSnowflake} />,
    imageBack: snowfallImageURL,
  },
  95: {
    description: 'Thunderstorm: Slight or moderate',
    descriptionShort: 'Thunderstorm',
    icon: 'fa-solid fa-cloud-bolt',
    weatherIcon: <Icon icon={Icons.faCloudBolt} />,
    imageBack: thunderImageURL,
  },
  96: {
    description: 'Thunderstorm with slight and heavy hail',
    descriptionShort: 'Light Thunderstorms With Hail',
    icon: 'fa-solid fa-bolt',
    weatherIcon: <Icon icon={Icons.faBolt} />,
    imageBack: thunderImageURL,
  },
  99: {
    description: 'Thunderstorm with slight and heavy hail',
    descriptionShort: 'Thunderstorm With Hail',
    icon: 'fa-solid fa-bolt',
    weatherIcon: <Icon icon={Icons.faBolt} />,
    imageBack: thunderImageURL,
  },
}
